const MODULE_NAME = "sc/actions/ui/forms/";

// Form Actions
export const SUBMITTED = `@@${MODULE_NAME}SUBMITTED`;
export const SUBMIT_VALIDATION_FAILED = `@@${MODULE_NAME}SUBMIT_VALIDATION_FAILED`;
export const SUBMIT_FAILED = `@@${MODULE_NAME}SUBMIT_FAILED`;
export const SUBMIT_SUCCEEDED = `@@${MODULE_NAME}SUBMIT_SUCCEEDED`;
export const RESET = `@@${MODULE_NAME}RESET`;

const PROCESS = `@@${MODULE_NAME}PROCESS`;
export const actionTypeInForm = originalActionType =>
  `${PROCESS}/${originalActionType}`;

// Creators
export const submitted = (id, action) => ({
  type: SUBMITTED,
  payload: {
    id,
    action,
  },
});

export const processFormAction = (id, action) => ({
  type: actionTypeInForm(action.type),
  payload: {
    ...action.payload,
  },
  formId: id,
  onSubmitValidationFail: (code, details) =>
    submitValidationFailed(id, code, details),
  // TODO: This should be modified to "onSubmitFailed"
  onFail: (code, details) => submitFailed(id, code, details),
  onSuccess: (code, details) => submitSucceeded(id, code, details),
  onError: (error, details) => submitFailed(id, error.message, details),
});

export const submitValidationFailed = (id, code, details) => ({
  type: SUBMIT_VALIDATION_FAILED,
  payload: {
    id,
    code,
    details,
  },
});

export const submitFailed = (id, code, details) => ({
  type: SUBMIT_FAILED,
  payload: {
    id,
    code,
    details,
  },
});

export const submitSucceeded = (id, code, details) => ({
  type: SUBMIT_SUCCEEDED,
  payload: {
    id,
    code,
    details,
  },
});

export const reset = id => ({
  type: RESET,
  payload: {
    id,
  },
});



// WEBPACK FOOTER //
// ./src/sc/actions/ui/forms.js